export default [{
        key: "title",
        label: "Event Title",
        order: 1,
        type: "string",
        group: "general"
    },
    {
        key: "startDate",
        label: "Start Date",
        order: 2,
        type: "string",
        group: "general"
    },
    {
        key: "startTime",
        label: "Start Time",
        order: 3,
        type: "string",
        group: "general"
    },
    {
        key: "estRuntime",
        label: "Estimated Runtime",
        order: 4,
        type: "string",
        group: "general"
    },
    {
        key: "private",
        label: "Private",
        order: 5,
        type: "bool",
        group: "general"
    },
    {
        key: "description",
        label: "Event Description",
        order: 6,
        type: "string",
        group: "general"
    },
    {
        key: "notes",
        label: "Notes",
        order: 7,
        type: "string",
        group: "general"
    },
    {
        key: "streamtext",
        label: "Captions",
        order: 8,
        type: "string",
        group: "general"
    },


    // Automation
    {
        key: "autoStart",
        label: "Automate Start",
        order: 9,
        type: "bool",
        group: "automation"
    },{
        key: "autoStop",
        label: "Automate Stop",
        order: 10,
        type: "bool",
        group: "automation"
    },{
        key: "liveToBreak",
        label: "Go To Break After Start",
        order: 11,
        type: "bool",
        group: "automation"
    },{
        key: "stopDate",
        label: "Stop Date",
        order: 12,
        type: "string",
        group: "automation"
    },
    {
        key: "stopTime",
        label: "Stop Time",
        order: 13,
        type: "string",
        group: "automation"
    },
    {
        key: "preroll",
        label: "Pre-Roll",
        order: 14,
        type: "number",
        group: "automation"
    },
    {
        key: "assignedEncoder",
        label: "Assigned Encoder",
        order: 15,
        type: "object",
        group: "automation"
    }
];

// Ancillary
// encoderDetails
// isChatEnabled
// playerPref
// facebookLive
// customID

// {
//     key: "startDateTime",
//     label: "Start Date/Time",
//     order: 2,
//     type: "string",
//     group: "general"
// },